module.exports = __webpack_public_path__ + "img/company2.7c031eeb.png";